{
  "loading": "Načítava sa...",
  "loadingMore": "Načítava sa viac..."
}